<template>
  <main class="bg-white dark:bg-slate-900">
    <NavBar/>
    <section class="mt-16 bg-zinc-100">
      <div class="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 class="text-black text-3xl md:text-5xl font-bold mb-2 text-center">
          Términos y Condiciones
        </h1>
        <p class="text-sm text-gray-600 text-center mb-10">
          Última actualización: 20 de junio de 2026
        </p>

        <div class="space-y-8 text-sm text-black text-justify leading-relaxed">
          <p>
            Los presentes Términos y Condiciones (los "Términos") regulan el acceso y uso de
            los sitios web, aplicaciones y servicios (los "Servicios") ofrecidos por
            <strong>Sfera Digital</strong> ("Sfera Digital", "nosotros" o "nuestro"). Al
            acceder o utilizar nuestros Servicios usted ("Usuario") acepta quedar obligado por
            estos Términos. Si no está de acuerdo, le pedimos no utilizar los Servicios.
          </p>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">1. Sobre Sfera Digital</h2>
            <p>
              Sfera Digital es una agencia de marketing digital que ofrece servicios de
              marketing digital, gestión de redes sociales, desarrollo web, desarrollo de
              aplicaciones y marketing offline en México y América del Sur. En el marco de
              estos servicios podemos integrar plataformas de terceros, incluyendo APIs de
              TikTok, para administrar contenido y campañas en nombre de nuestros clientes.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">2. Uso de los Servicios</h2>
            <p>
              El Usuario se compromete a utilizar los Servicios de forma lícita y conforme a
              estos Términos, a la legislación aplicable y a las políticas de las plataformas de
              terceros integradas. Está prohibido utilizar los Servicios para fines fraudulentos,
              para vulnerar derechos de terceros o para publicar contenido ilegal, ofensivo o que
              infrinja derechos de propiedad intelectual.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">3. Integraciones con plataformas de terceros</h2>
            <p>
              Nuestros Servicios pueden conectarse con plataformas de terceros como TikTok a
              través de sus APIs oficiales. Al autorizar dicha conexión, el Usuario otorga a
              Sfera Digital permiso para acceder, publicar y administrar contenido en su cuenta
              únicamente con el fin de prestar los Servicios contratados. El uso de estas
              integraciones también se rige por los términos y políticas de la plataforma
              correspondiente (por ejemplo, los Términos de Servicio de TikTok). El Usuario es
              responsable de cumplir con dichas políticas.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">4. Cuentas y credenciales</h2>
            <p>
              El Usuario es responsable de mantener la confidencialidad de sus credenciales de
              acceso y de toda la actividad realizada a través de su cuenta. Debe notificarnos
              de inmediato sobre cualquier uso no autorizado. Podemos suspender o cancelar el
              acceso en caso de incumplimiento de estos Términos.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">5. Propiedad intelectual</h2>
            <p>
              Todo el contenido, marcas, logotipos y software relacionados con los Servicios son
              propiedad de Sfera Digital o de sus licenciantes y están protegidos por las leyes
              de propiedad intelectual. El Usuario conserva la titularidad del contenido que
              proporcione, otorgando a Sfera Digital una licencia limitada para utilizarlo con el
              único fin de prestar los Servicios.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">6. Privacidad y datos</h2>
            <p>
              El tratamiento de los datos personales se realiza conforme a nuestra Política de
              Privacidad. Los datos obtenidos a través de integraciones con terceros se utilizan
              exclusivamente para prestar los Servicios y no se venden a terceros. Para cualquier
              duda sobre el manejo de datos puede contactarnos en la dirección indicada abajo.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">7. Limitación de responsabilidad</h2>
            <p>
              Los Servicios se ofrecen "tal cual" y "según disponibilidad". En la medida permitida
              por la ley, Sfera Digital no será responsable por daños indirectos, incidentales o
              consecuentes derivados del uso o la imposibilidad de uso de los Servicios, ni por
              interrupciones, errores o cambios en las plataformas de terceros integradas.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">8. Modificaciones</h2>
            <p>
              Podemos actualizar estos Términos en cualquier momento. Las modificaciones entrarán
              en vigor al publicarse en esta página. El uso continuado de los Servicios después de
              dichos cambios implica la aceptación de los Términos actualizados.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">9. Legislación aplicable</h2>
            <p>
              Estos Términos se rigen por las leyes de los Estados Unidos Mexicanos. Cualquier
              controversia se someterá a los tribunales competentes correspondientes, salvo
              disposición legal en contrario.
            </p>
          </div>

          <div>
            <h2 class="text-black text-xl md:text-2xl font-bold mb-3">10. Contacto</h2>
            <p>
              Si tiene preguntas sobre estos Términos y Condiciones, puede contactarnos en:
            </p>
            <p class="mt-2">
              <strong>Sfera Digital</strong><br/>
              Correo electrónico:
              <a href="mailto:contacto@sfera-digital.com" class="text-blue-600 underline">
                contacto@sfera-digital.com
              </a>
            </p>
          </div>
        </div>
      </div>
    </section>
    <FooterComponent/>
  </main>
</template>

<script>
import NavBar from '@/partials/NavBar.vue';
import FooterComponent from '@/partials/FooterComponent.vue';

export default {
  name: 'TermsPage',
  components: {
    NavBar,
    FooterComponent,
  },
}
</script>
